/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import analytics from "../analytics/analytics";
import facebookEvents from "../analytics/facebook-events";
import doubleclickEvents from "../analytics/doubleclick-events";
import environment from "../modules/environment";
import userProfiler from "../modules/userprofiler";
import browser from "../utils/browser";

export default baustein.register("email-capture-success", {
    defaultOptions: {
        captureType: "unknown",
        alertForId: null
    },

    init() {
        if (this.isMobile()) {
            // else email-capture-overlay does this
            if (this.options.captureType === "designer_update") {
                userProfiler.saveDesignerUpdate(this.options.alertForId);
            } else if (this.options.captureType === "stock_alert") {
                userProfiler.saveStockAlert(this.options.alertForId);
            } else if (this.options.captureType === "anon_lyst") {
                userProfiler.saveLystedProduct(this.options.alertForId);
            } else if (this.options.captureType == "search_subscription") {
                userProfiler.saveSubscribedSeachTerm(this.options.alertForId);
            }
            this.processSuccess(this.options.captureType);
        }
    },

    isMobile() {
        return browser.getViewport() === browser.VIEWPORTS.MOBILE;
    },

    processSuccess(eventAction) {
        analytics.event("email_capture", "created", eventAction);
        analytics.tagEvent(analytics.TAG_NETWORKS.FACEBOOK, facebookEvents.EMAIL_SIGNUP);
        analytics.tagEvent(analytics.TAG_NETWORKS.DOUBLECLICK, doubleclickEvents.ANON_SIGN_UP, {
            atc_country: environment.get("country")
        });
    }
});

